"use client";

import { useEffect } from "react";
import { useContentLocaleStore } from "@/stores/locale-store";
import { SUPPORTED_LANGUAGES } from "@/lib/constants";

export interface ActiveLanguage {
  code: string;
  name: string;
  flag: string;
}

/** Languages a translation can actually be saved in — use this, not `SUPPORTED_LANGUAGES` directly, for any language picker. */
export function useActiveLanguages(): { languages: ActiveLanguage[]; isLoading: boolean } {
  const { locales, isLoaded, isLoading, fetchLocales } = useContentLocaleStore();
  useEffect(() => {
    fetchLocales();
  }, [fetchLocales]);

  const languages: ActiveLanguage[] = locales.map((l) => {
    const display = SUPPORTED_LANGUAGES.find((d) => d.code === l.code);
    return { code: l.code, name: display?.localName ?? l.label, flag: display?.flag ?? "🌐" };
  });

  return { languages, isLoading: isLoading || !isLoaded };
}
